import { Document, Page, pdf, Text, View } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { IntlProvider } from 'react-intl';

import { reduxStore } from '@/store/store';
import { DataboxTitleContainer, WrappableDataboxContainer } from '@/utils/export/components/databox/databox';
import Footer from '@/utils/export/components/footer/footer';
import Header from '@/utils/export/components/header/header';
import exportResponseToPDFNewStyles from '@/utils/export/exportResponseToPDF/exportResponseToPDFNew.styles';
import FontProvider from '@/utils/export/utils/fontProvider/FontProvider';
import { markdownContainsCodeBlock, renderMarkdownString } from '@/utils/export/utils/renderNodeToPDF/renderNodeToPDF';
import { usePdfLabels } from "@/utils/export/utils/usePdfLabls";

const SummaryBlock = ({ title, content }: { title: string; content: string }) => (
  <View style={exportResponseToPDFNewStyles.marginTop}>
    <WrappableDataboxContainer>
      <DataboxTitleContainer>
        <Text style={exportResponseToPDFNewStyles.marginLeft}>{title}</Text>
      </DataboxTitleContainer>
      <View style={exportResponseToPDFNewStyles.marginTop}>{renderMarkdownString(content)}</View>
    </WrappableDataboxContainer>
  </View>
);

const MyDocument = ({ question, message, containsTable }: { question: string; message: string; containsTable: boolean }) => {
  const { questionTitle, answerTitle } = usePdfLabels();

  return (
    <FontProvider locale="en">
      <Document>
        <Page
          size="A4"
          style={exportResponseToPDFNewStyles.page}
          orientation={containsTable ? 'landscape' : 'portrait'}
        >
          <Header isFull={true} />
          <SummaryBlock title={questionTitle} content={question} />
          <SummaryBlock title={answerTitle} content={message} />
          <Footer />
        </Page>
      </Document>
    </FontProvider>
  );
};

export const exportResponseToPDF = async (question: string, message: string, messages: Record<string, string>) => {
  const containsTable = markdownContainsCodeBlock(message);
  const fleetName = reduxStore.getState().login.userProfile?.fleetName ?? '';

  const date = new Date().toISOString().slice(0, 10).replace(/-/g, '_');
  const fileName = `FleetAssistant_${fleetName}_${date}.pdf`;

  const blob = await pdf(
    <IntlProvider locale="en" messages={messages}>
      <MyDocument question={question} message={message} containsTable={containsTable} />
        </IntlProvider>
  ).toBlob();

  saveAs(blob, fileName);
};
